"use client";

import { getDomainDisplayNames, getLocaleAsset, openInNewTab, separateLocale } from "@tosize/ui";
import Image from "next/image";
import { CommandWrapper } from "~/app/[lang]/command/Wrapper";
import type { LangParams } from "~/app/[lang]/layout";
import { getDomains, getHrefLangs } from "~/lib/utils";
import { CommandItem } from "../utils/Item";

export function LanguagePage({ lang }: LangParams) {
	const { domains } = getDomains(lang);

	if (!domains?.length) {
		return null;
	}

	return (
		<CommandWrapper page="language">
			{domains.map((item, index) => {
				const { country } = separateLocale(item.locale);
				const { region, language } = getDomainDisplayNames(item.locale);

				return (
					<CommandItem
						key={index}
						onSelect={() => {
							const hrefLang = getHrefLangs(item.locale);
							const href = hrefLang?.href ?? item?.href;

							return openInNewTab(href);
						}}
					>
						<div className="flex items-center gap-2">
							<Image
								src={getLocaleAsset(`countries/jpg/${country}.jpg`)}
								height="12"
								width="16"
								alt={region ?? language ?? country}
							/>
							<span>
								{region} ({language})
							</span>
						</div>
					</CommandItem>
				);
			})}
		</CommandWrapper>
	);
}
